import React from 'react'
import Link from './link'
import Icon from './icon'

export default (props) => (
  <Link {...props}>
    <Icon icon={props.icon}></Icon>
  </Link>
)